<template>
  <svg :class="`icon ${asc ? 'asc' : 'desc'}`" viewBox="0 0 20 20" height="13" width="13" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0h20v20H0V0z" fill="none" />
    <path d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z" />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ArrowIcon',
  props: {
    asc: {
      type: Boolean,
    },
  },
});
</script>

<style scoped>
.icon {
  transform: rotateX(180deg);
}
.desc {
  transform: rotateX(180deg);
  transition: transform 0.2s;
  margin-top: 0px;
}
.asc {
  transform: rotateX(360deg);
  transition: transform 0.2s;
  margin-bottom: 0px;
}
</style>
